import OrderedWorkspace from "../workspace/OrderedWorkspace";

const ExtraValuesWorkspace = ({
  workId,
  summary,
  created,
  monthly,
  detail,
  panel,
}) => (
  <OrderedWorkspace
    key={workId ?? "no-work"}
    className="extra-values-workspace"
    context={{ workId }}
    blocks={[
      { id: "summary", label: "Visão geral financeira", content: summary },
      { id: "created", label: "Lançamentos existentes", content: created },
      { id: "monthly", label: "Lançamentos por mês", content: monthly },
      { id: "detail", label: "EAP da obra", content: detail },
    ]}
    panel={panel}
  />
);

export default ExtraValuesWorkspace;
